import { Box, Theme, Typography } from "@mui/material";
import { TFunction } from "i18next";
import { TriangleAlert } from "lucide-react";
import type { LearningObject } from "types";

export function alertNoSmartLearning(
  smartLearningObjects: LearningObject[], 
  theme: Theme,
  t: TFunction<"translation", undefined>
) {
  if(smartLearningObjects.length < 1) return (
    <Box
      tabIndex={ -1 }
      sx={ {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "2rem",
        padding: "0.10938rem 0.4375rem",
        gap: "0.25rem",
        border: `1px solid ${theme.customColors.border}`,
        backgroundColor: theme.customColors.backgroundSecondaryAlternative,
        borderRadius: "0.25rem",
        width: "fit-content"
      } }
    >
      <TriangleAlert size="1rem" color={ theme.customColors.textTag } />
      <Typography 
        tabIndex={ -1 }
        sx={ { 
          fontSize: "0.75rem",
          fontWeight: "600"
        } }
        color={ theme.customColors.textTag }>
        { t("no_activities_in_progress") }
      </Typography>
    </Box>
  );
}
